<template>
  <div class="content-wrapper">
    <div class="content-body">
      <go-back-button />

      <h1 class="page-title mb-4">{{ title }}</h1>

      <slot />
    </div>

    <footer class="sticky-button-container">
      <div class="sticky-button-wrapper">
        <slot name="footer" />
      </div>
    </footer>
  </div>
</template>

<script>
import GoBackButton from "@/components/global/go-back-button.vue";

export default {
  name: "PageFormWrapper",
  components: { GoBackButton },
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.content-wrapper {
  width: 100%;
}

.content-body {
  margin-bottom: 75px;

  .page-title {
    margin: 0;
    color: var(--color-text-neutral-on-white, #1c0f30);
    font-family: var(--typography-font-family-text-primary, Inter);
    font-size: var(--typography-font-size-fs-700, 24px);
    font-style: normal;
    font-weight: var(--typography-font-weight-fw-600, 600);
    line-height: 120%;
    margin-bottom: 32px;
  }
}

.sticky-button-container {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  width: calc(100% - var(--sidebar-width, 264px));
  position: fixed;
  bottom: 0;
  right: 0;
  background-color: white;
  padding: 16px 100px 16px 24px;
  z-index: 4;
  border-top: 1px solid var(--color-stroke-neutral-default);
}
</style>
